import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_402: DocMigration = {
  maxSchemaVersion: "0.0.402",
  description: "Fix schema issues",
  apply(json: any) {
    if (json.propInstances) {
      for (const propId in json.propInstances) {
        const prop = json.propInstances[propId];

        if (prop.name === undefined) {
          prop.name = "";
        }

        if (prop.type === "WALL") {
          if (prop.lateralOffsetNormalized === undefined) {
            prop.lateralOffsetNormalized = false;
          }

          if (prop.lateralOffset === undefined) {
            prop.lateralOffset = 0;
          }

          if (prop.mirrorPropX === undefined) {
            prop.mirrorPropX = false;
          }

          if (prop.mirrorPropY === undefined) {
            prop.mirrorPropY = false;
          }

          if (prop.verticalAlignment === undefined) {
            prop.verticalAlignment = "ORIGIN";
          }

          if (prop.horizontalAlignment === undefined) {
            prop.horizontalAlignment = "ORIGIN";
          }

          if (prop.horizontalDatum === undefined) {
            prop.horizontalDatum = "OUTSIDE_OF_SURFACE";
          }

          if (prop.verticalDatum === undefined) {
            prop.verticalDatum = "FLOOR_ELEVATION";
          }

          if (prop.lateralDatum === undefined) {
            prop.lateralDatum = "INSIDE_FACE_OF_FRAMING";
          }

          if (prop.lateralAlignment === undefined) {
            prop.lateralAlignment = "ORIGIN";
          }

          if (prop.placementStyle === undefined) {
            prop.placementStyle = "DEPRECATED";
          }
        }
      }
    }

    if (json.stairBlocks) {
      for (const entityId in json.stairBlocks) {
        const entity = json.stairBlocks[entityId];

        if (entity.name === undefined) {
          entity.name = "";
        }
      }
    }

    if (json.gableOpenings) {
      let counter = 0;
      for (const entityId in json.gableOpenings) {
        const entity = json.gableOpenings[entityId];

        if (entity.sortIndex === undefined) {
          entity.sortIndex = counter++;
        }
      }
    }

    if (json.casework) {
      for (const entityId in json.casework) {
        const entity = json.casework[entityId];

        if (entity.name === undefined) {
          entity.name = "";
        }

        if (entity.type === "DYNAMIC" || entity.type === "FIXED") {
          if (entity.material === undefined) {
            entity.material = "propDefault0";
          }
        }
      }
    }

    if (json.openings) {
      for (const entityId in json.openings) {
        const entity = json.openings[entityId];

        if (entity.type === "DOOR") {
          if (entity.verticalOffset === undefined) {
            entity.verticalOffset = 0;
          }

          if (entity.lateralOffset === undefined) {
            entity.lateralOffset = 0;
          }

          if (entity.wallStripDomain === undefined) {
            entity.wallStripDomain = false;
          }
        }

        if (entity.type === "WINDOW") {
          if (entity.lateralDatum === undefined) {
            entity.lateralDatum = "OUTSIDE_FACE_OF_SUBSTRATE";
          }

          if (entity.lateralAlignment === undefined) {
            entity.lateralAlignment = "OUTSIDE_FACE";
          }

          if (entity.verticalDatum === undefined) {
            entity.verticalDatum = "WINDOW_HEAD_HEIGHT";
          }

          if (entity.verticalAlignment === undefined) {
            entity.verticalAlignment = "TOP";
          }

          if (entity.lateralOffset === undefined) {
            entity.lateralOffset = 0;
          }

          if (entity.verticalOffset === undefined) {
            entity.verticalOffset = 0;
          }

          if (entity.lateralOffsetNormalized === undefined) {
            entity.lateralOffsetNormalized = false;
          }

          if (entity.wallStripDomain === undefined) {
            entity.wallStripDomain = false;
          }
        }

        if (entity.type === "SOLID") {
          if (entity.wallStripDomain === undefined) {
            entity.wallStripDomain = false;
          }
        }
      }
    }

    if (json.electricalDevices) {
      for (const entityId in json.electricalDevices) {
        const entity = json.electricalDevices[entityId];
        const position = entity.position;

        if (position?.type === "WALL") {
          if (position.lateralDatum === undefined) {
            position.lateralDatum = "INSIDE_FACE_OF_SUBSTRATE";
          }
        }
      }
    }

    if (json.facadeSweepStrata) {
      for (const entityId in json.facadeSweepStrata) {
        const entity = json.facadeSweepStrata[entityId];

        if (entity.sweep?.elevationNote === null) {
          entity.sweep.elevationNote = "";
        }
      }
    }

    if (json.sheets) {
      for (const entityId in json.sheets) {
        const entity = json.sheets[entityId];

        if (entity.removeTitleBlock === undefined) {
          entity.removeTitleBlock = false;
        }
      }
    }

    if (json.annotation) {
      for (const entityId in json.annotation) {
        const entity = json.annotation[entityId];

        if (entity.type === "LINEWORK") {
          if (entity.fillType === undefined) {
            entity.fillType = "NONE";
          }
        }
      }
    }

    if (json.dormers) {
      let counter = 0;
      for (const entityId in json.dormers) {
        const entity = json.dormers[entityId];

        if (entity.sortIndex === undefined) {
          entity.sortIndex = counter++;
        }

        const gableOpeningPlacement = entity.gableOpeningPlacement;
        if (entity.gableOpeningPlacement) {
          if (gableOpeningPlacement.name === undefined) {
            gableOpeningPlacement.name = "";
          }

          if (gableOpeningPlacement.entityType === undefined) {
            gableOpeningPlacement.entityType = "GABLE_OPENING";
          }

          if (gableOpeningPlacement.id === undefined) {
            gableOpeningPlacement.id = uid();
          }

          if (gableOpeningPlacement.sortIndex === undefined) {
            gableOpeningPlacement.sortIndex = counter++;
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_402;
